module.exports = __webpack_public_path__ + "img/qr.11f6b869.jpg";